"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Button_1 = __importDefault(require("./Button"));
const ColorType_1 = __importDefault(require("./enums/ColorType"));
const IconType_1 = __importDefault(require("./enums/IconType"));
const DefaultIcon_1 = __importDefault(require("./icons/DefaultIcon"));
const Alert = (props) => {
    var iconType;
    var iconColor;
    var mainClass;
    switch (props.type) {
        case "error":
            iconType = IconType_1.default.Error;
            iconColor = ColorType_1.default.Red;
            mainClass = "alert--error";
            break;
        case "success":
            iconType = IconType_1.default.AlertSuccess;
            iconColor = ColorType_1.default.Green;
            mainClass = "alert--success";
            break;
        case "info":
            iconType = IconType_1.default.Information;
            iconColor = ColorType_1.default.Blue;
            mainClass = "alert--info";
            break;
    }
    return (react_1.default.createElement("div", { className: "alert-container" },
        react_1.default.createElement("div", { className: `alert ${mainClass}` },
            react_1.default.createElement("div", { className: "alert__message" },
                react_1.default.createElement(DefaultIcon_1.default, { size: "24", color: iconColor, type: iconType }),
                react_1.default.createElement("p", { className: "alert__label" }, props.label)),
            react_1.default.createElement(Button_1.default, { type: "tertiary", label: "", icon: IconType_1.default.Cancel, state: "enabled", handlerFunction: props.closeFunction }))));
};
exports.default = Alert;
